import { useFeatureFlag } from './use-feature-flag';

// add 'as const' when add new keys
// export const FEATURES_KEYS = ['showFeatureExample'] as const;

// use without features
export const FEATURES_KEYS = ['LOGGER', 'STOP_OBFUSCATING_EVENTS'] as const;

export const useFeatures = () => {
  const { isKassir } = useFeatureFlag();

  return Object.assign(
    {},
    ...FEATURES_KEYS.map((key) => ({
      get [key]() {
        if (!isKassir) return false;
        return localStorage.getItem(key) === 'true';
      },
    }))
  ) as { readonly [key in (typeof FEATURES_KEYS)[number]]: boolean };
};
